import React, { useLayoutEffect } from 'react'
import { Calendar } from 'primereact/calendar'

const TimeEditor = ({ options, validationErrors }) => {
    const rowIndex = options.rowIndex

    useLayoutEffect(() => {
        if (options.rowData?._editKey !== undefined) {
            options.editorCallback(null)
        }
    }, [])

    return (
        <Calendar
            value={options.value}
            onChange={(e) => options.editorCallback(e.target.value)}
            showTime={true}
            timeOnly={true}
            hourFormat="24"
            className={validationErrors[rowIndex] && validationErrors[rowIndex][options.field] ? 'p-invalid' : ''} />
    )
}

export default TimeEditor
